import { render, staticRenderFns } from "./proposedDocumentList.vue?vue&type=template&id=e2de5340&scoped=true&"
import script from "./proposedDocumentList.vue?vue&type=script&lang=js&"
export * from "./proposedDocumentList.vue?vue&type=script&lang=js&"
import style0 from "./proposedDocumentList.vue?vue&type=style&index=0&id=e2de5340&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2de5340",
  null
  
)

export default component.exports